// Shared gameplay palette used by board, versus board, and side VFX.
// Colors are lower-case to keep strict equality checks deterministic.
export const GAME_TILE_COLORS = [
  "#00d4ff",
  "#ff6b35",
  "#e6c430",
  "#00ff88",
  "#b565ff",
  "#ff1a75",
  "#00e5cc",
  "#ff9500",
  "#00fff5",
  "#4da6ff",
  "#d4b840",
  "#9d7aff"
] as const;

export const GAME_GRID_ACCENT_COLORS = [
  "#1f315a",
  "#2a4a7a",
  "#3c6ca8",
  "#9fc4ff"
] as const;

export const SIDE_FX_ALLOWED_COLORS = [
  ...new Set<string>([
    ...GAME_TILE_COLORS,
    ...GAME_GRID_ACCENT_COLORS
  ])
] as const;
